<template>
  <div class="body">
    <Hero imageName="American-Credit-Business-Loans.png" altText="American Credit Business Loans">
      <!-- landing-hero.jpeg -->
      <template>
        <h1>Your quick and simple equipment loans and invoice/AR financing</h1>
        <router-link to="/get-start" tag="button" class="cta" id="eventBtn"
          >Apply Now</router-link
        >
        <p>
          Looking for equipment, invoice, or asset-based financing? Try us now.
          See our fast, simple, fully digital process.
          <a href="/get-start"
            >Get Started <i class="fa fa-long-arrow-right"></i
          ></a>
        </p>
        <div class="app-badges">
          <a
            href="https://apps.apple.com/us/app/amcredit/id1489544972#?platform=iphone"
            rel="nofollow"
            target="_blank"
          >
            <img
              src="../assets/imgs/app_store_black.png"
              alt="American Credit mobile app in App Store"
              width="162"
              height="48"
            />
          </a>
          <a :href="AndroidApp" rel="nofollow" target="_blank">
            <img
              src="../assets/imgs/google_play_black.png"
              alt="American Credit mobile app in Google Play"
              width="164"
              height="48"
            />
          </a></div
      ></template>
    </Hero>

    <Benefits></Benefits>

    <div style="width: 100%; background: white">
      <div class="container platform products">
        <div class="row equipment-product">
          <div class="col-12 col-lg-5 offset-lg-1 equipment-product-left">
            <lazy-youtube-video
              src="https://www.youtube.com/embed/7v1c7cM19l0"
              :iframeAttributes="{
                allowfullscreen: true,
                frameborder: 0,
                allow:
                  'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
              }"
              :style="{ width: '100%', maxWidth: '560px', height: 'auto' }"
            />
          </div>
          <div class="col-12 col-lg-5 equipment-product-right">
            <div>
              <h2 class="product-title">
                Maximize your profitability with flexible equipment financing
                and asset-based loans
              </h2>
              <p class="product-summary">
                <span
                  >American Credit<sup>®</sup> Asset-Based Loans starting
                  4.5%</span
                >
              </p>
              <br />
              <div class="hover-element">
                <p>
                  <span class="product-read-more"
                    ><a
                      href="javascript:void(0)"
                      v-on:click="toggle1 = !toggle1"
                      >Read more
                      <i
                        class="fa fa-chevron-right"
                        style="color: #5456ff"
                      ></i></a
                  ></span>
                </p>
                <p v-show="toggle1" class="hover-display-content">
                  <span style="font-weight: 700"
                    >American Credit understands the dilemma facing borrowers in
                    equipment financing: often the financing and purchase are
                    bundled. </span
                  >We arm the equipment purchaser with pre-approval on financing
                  so that, when they shop, they concentrate on getting the best
                  deal on the equipment price. Our pre-approvals significantly
                  enhance the equipment purchasers’ bargaining power.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container platform products">
        <div class="row invoice-product">
          <div class="col-12 col-lg-5 offset-lg-1 invoice-product-left">
            <div>
              <h2 class="product-title">
                Better cash flow with invoice/AR financing
              </h2>
              <p class="product-summary">
                <span
                  >We understand where your time is best spent. So our
                  application process takes almost no time at all. </span
                ><span style="color: #5456ff; font-weight: 400"
                  ><a href="/get-start">See how fast we make it.</a></span
                >
              </p>
              <br />
              <div class="hover-element">
                <p>
                  <span class="product-read-more"
                    ><a
                      href="javascript:void(0)"
                      v-on:click="toggle2 = !toggle2"
                      >Read more
                      <i
                        class="fa fa-chevron-right"
                        style="color: #5456ff"
                      ></i></a
                  ></span>
                </p>
                <p v-show="toggle2" class="hover-display-content">
                  <span style="font-weight: 700"
                    >For borrowers in invoice financing it is difficult to find
                    a stable credit provider who can handle their frequent
                    short-term credit needs. </span
                  >American Credit commits itself to provide our clients not
                  only invoice financing but also secured loans such as
                  inventory financing, bridge loans, upgrading and renovations,
                  as well as opening new branches. We are your one-stop business
                  loan provider.
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5 invoice-product-right">
            <img
              :src="require('../assets/imgs/female-factory.jpeg')"
              :srcset="
                require('../assets/imgs/female-factory-320w.jpeg') +
                ' 320w, ' +
                require('../assets/imgs/female-factory-640w.jpeg') +
                ' 640w, ' +
                require('../assets/imgs/female-factory-960w.jpeg') +
                ' 960w'
              "
              alt="confident female business owner near factory equipment purchased with invoice financing"
              width="500"
              height="350"
            />
          </div>
        </div>
      </div>
    </div>

    <Testimonial></Testimonial>

    <HowWorks></HowWorks>

    <Trust></Trust>

    <div style="width: 100%; padding: 40px 10px">
      <div class="elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"></div>
    </div>
    <div style="width: 100%; background-color: white;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1">
            <div style="padding-top: 20px; font-family: Biotif; font-weight: 400; font-size: 14px;">
              Footnote
            </div>
            <div class="column">
              <ul style="margin: 0; padding-left: 15px;">
                <li style="list-style: decimal; font-family: Biotif; font-weight: 400; font-size: 14px;">Please consult with a tax professional for qualification and details.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as types from "../vuex/types";
import api from "../vuex/api/index";
import LazyYoutubeVideo from "vue-lazy-youtube-video/dist/vue-lazy-youtube-video.min.js";

import Hero from "./../components/Hero.vue";
// import Benefits from "./../components/Benefits.vue";
// import Testimonial from "./../components/Testimonial.vue";
// import HowWorks from "./../components/HowWorks.vue";
// import Trust from "./../components/Trust.vue";

// const Hero = () => import('./../components/Hero.vue');
const Benefits = () => import("./../components/Benefits.vue");
const Testimonial = () => import("./../components/Testimonial.vue");
const HowWorks = () => import("./../components/HowWorks.vue");
const Trust = () => import("./../components/Trust.vue");

export default {
  components: {
    Hero,
    LazyYoutubeVideo,
    Benefits,
    Testimonial,
    HowWorks,
    Trust,
  },
  data() {
    return {
      toggle1: false,
      toggle2: false,
      imgHeight: "300px",
      carouselData: [
        {
          src: "/static/images/testimonial-1.jpg",
        },
        {
          src: "/static/images/testimonial-2.jpg",
        },
        {
          src: "/static/images/testimonial-3.jpg",
        },
        {
          src: "/static/images/testimonial-4.jpg",
        },
        {
          src: "/static/images/testimonial-5.jpg",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
      carousel: types.GET_INDEX_CAROUSEL,
      products: types.GET_HOT_PRODUCTS,
      userInfo: types.GET_USER,
    }),
  },
  methods: {
    gotoApply(item) {
      api
        .get("/mobile/item/loanItemFrontApply/mgxyIsCanApply.ht", {
          tokenId: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$router.push(`/applyLoan/${item.productId}/sbl`);
          } else if (res.data.code == 1) {
            this.$alert(res.data.msg);
          }
        });
    },
    setImgHeight() {
      const carouselItemImgList = document.getElementsByClassName(
        "index__carousel-item"
      );
      for (let i = 0; i < carouselItemImgList.length; i++) {
        this.imgHeight = `${carouselItemImgList[i].clientHeight - 3}px`;
      }
    },
    register() {
      this.$router.push({
        path: "/get-start",
      });
    },
    investerNew() {
      alert("ok");
      this.$router.push("/investerNew");
    },
  },

  mounted() {
    document.getElementById("eventBtn").onclick = trackClick;

    var _this = this;

    function trackClick() {
      // window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]);
      // Krux('admEvent', 'NjhcPuTz', {event_type:'clk'});
      // navigate.push("/get-start");
      _this.register();
    }

    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title =
      "Asset Based Lending & Invoice Financing | American Credit";
    meta.content =
      "Asset-based Business Loans & Equipment Loans up to $5M. Invoice Financing up to $2.5M. Receive your funds in as little as 3-4 Business Days. Apply Now!";
    keywords.content =
      "asset-based loan, equipment loan, AR Invoice financing, Business Loans, small business financing, small business credit, american credit";
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/css/index.css";
@import "../assets/css/fonts.css";
@import "../assets/css/bubbles.css";

.app-badges {
  img {
    height: 48px;
  }
}

.business-loan {
  .business-loan-box {
    min-height: 750px;

    .business-loan-box-left-inner {
      padding-top: 150px;
      padding-bottom: 150px;
      @media (max-width: 992px) {
        padding-top: 50px;
        padding-bottom: 50px;
      }
      @media (max-width: 1200px) {
        padding-top: 100px;
        padding-bottom: 100px;
      }
      //@media (min-width: 993px) {
      //  padding-left: 95px;
      //}

      h1 {
        font-family: Biotif;
        color: #252525;
        font-size: 54px;
        font-weight: 700;
        margin-top: 0;
      }
    }

    .business-loan-box-right {
      .image-wrapper {
        position: absolute;
        width: unquote("min(45vw, 960px)");
        height: 100%;
        overflow-x: hidden;

        @media (max-width: 1200px) {
          width: 50vw;
        }
        @media (max-width: 992px) {
          width: 100vw;
          margin-left: calc(((100vw - 720px) / 2) * -1);
          position: relative;
        }

        @media (max-width: 768px) {
          width: 100%;
          position: relative;
          margin-left: 0;
        }
      }

      img {
        height: 90%;
        position: absolute;
        right: 40px;
        top: 40px;
        @media (max-width: 1200px) {
          right: -15%;
        }
        @media (max-width: 992px) {
          width: 100%;
          position: relative;
          right: 0;
        }
      }

      .image-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 33%;
        z-index: 3;
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0)
        );

        @media (max-width: 992px) {
          left: 0;
          right: 0;
          top: 0;
          height: 20%;
          width: 100%;
          z-index: 3;
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 0)
          );
        }
      }
    }
  }
}

.products {
  .equipment-product {
    height: 520px;

    .equipment-product-left {
      display: flex;
      align-items: center;
      img {
        height: auto;
        width: 500px;
        object-fit: contain;
        margin-top: 120px;
        margin-left: 0;
      }

      iframe {
        max-width: 100%;
        aspect-ratio: 560/315;
        height: auto;
        width: 100%;
      }
    }

    .equipment-product-right {
      display: flex;
      align-items: center;
    }
  }

  .invoice-product {
    height: 580px;

    .invoice-product-left {
      display: flex;
      align-items: center;
    }

    .invoice-product-right {
      display: flex;
      align-items: center;
      img {
        height: auto;
        width: 500px;
        object-fit: contain;

        margin-left: 0;
      }
    }
  }

  .product-title {
    font-family: Biotif;
    color: #272727;
    font-size: 36px;
    font-weight: 700;
  }

  .product-summary {
    font-size: 19px;
    line-height: 28px;
    margin-top: 25px;

    span {
      color: #686868;
      font-weight: 300;
    }
  }

  .product-read-more {
    color: #3c3c3c;
    font-size: 16px;
    font-weight: 700;
  }
}

.hover-element {
  position: relative;
}

.hover-element .hover-display-content {
  width: 640px;
  background-color: rgba(246, 249, 255, 0.8);
  color: #686868;
  text-align: left;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
}

@media (max-width: 768px) {
  .business-loan {
    .business-loan-box {
      min-height: 0px;

      .business-loan-box-left-inner {
        padding-top: 40px;
        padding-bottom: 40px;

        h1 {
          font-size: 30px !important;
        }
      }

      .business-loan-box-right {
        padding-left: 0;
        padding-right: 0;
        margin-top: 40px;
        position: relative;
        display: none;
        img {
          width: 100%;
          margin-top: 0;
          position: relative;
          bottom: 0;
        }
      }
    }
  }

  .products {
    .equipment-product {
      height: auto;

      .equipment-product-left {
        img {
          width: 90%;
          margin-top: 64px;
          margin-left: 5%;
        }
      }

      .equipment-product-right {
        padding-top: 0;
      }
    }

    .invoice-product {
      height: auto;

      .invoice-product-left {
        padding-top: 0;
      }

      .invoice-product-right {
        img {
          width: 90%;
          margin-top: 0;
          margin-bottom: 64px;
          margin-left: 5%;
        }
      }
    }

    .product-title {
      font-size: 24px;
      font-weight: 500;
    }

    .product-summary {
      font-size: 16px;
    }

    .product-read-more {
      font-size: 14px;
    }
  }

  br {
    height: 5px;
  }

  .hover-element .hover-display-content {
    background-color: rgba(246, 249, 255, 1);
    width: auto;
    left: 0;
    right: 0;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?294d4ea7